import React from 'react';
import LegalPolicyPage from '../components/content/LegalPolicyPage.jsx';
import { termsOfUseFallback } from './legalPageDefaults.js';

export default function TermsOfUsePage() {
  return <LegalPolicyPage slug="terms-of-use" fallback={termsOfUseFallback} />;
}
